import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { logoUrl } from '../../App';

function LoginScreen({ auth, showModal }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isResetMode, setIsResetMode] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (isResetMode) {
            if (!email) {
                showModal("Información Incompleta", "Por favor, ingresa tu correo electrónico.");
                setIsLoading(false);
                return;
            }
            try {
                await sendPasswordResetEmail(auth, email);
                showModal("Correo Enviado", "Si tu correo está registrado, recibirás un enlace para restablecer tu contraseña.");
            } catch (error) {
                showModal("Error", "No se pudo enviar el correo de restablecimiento. Inténtalo de nuevo.");
            }
        } else {
            if (!email || !password) {
                 showModal("Información Incompleta", "Por favor, ingresa correo y contraseña.");
                 setIsLoading(false);
                 return;
            }
            try {
                await signInWithEmailAndPassword(auth, email, password);
            } catch (error) {
                showModal("Error de Inicio de Sesión", "Correo o contraseña incorrectos.");
            }
        }
        setIsLoading(false);
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg">
                <img src={logoUrl} alt="Logo de la Empresa" className="mx-auto h-16 w-auto mb-4" />
                <h2 className="text-2xl font-bold text-center text-sky-700 mb-6">{isResetMode ? 'Recuperar Contraseña' : 'Iniciar Sesión'}</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Correo Electrónico</label>
                        <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required className="input-field mt-1" />
                    </div>
                    {!isResetMode && (
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Contraseña</label>
                            <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} required className="input-field mt-1" />
                        </div>
                    )}
                    <button type="submit" disabled={isLoading} className="w-full btn-primary">
                        {isLoading ? 'Procesando...' : (isResetMode ? 'Enviar Correo' : 'Ingresar')}
                    </button>
                    <div className="text-center">
                        <button type="button" onClick={() => setIsResetMode(!isResetMode)} className="text-sm text-sky-600 hover:underline">
                            {isResetMode ? 'Volver a Inicio de Sesión' : '¿Olvidaste tu contraseña?'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginScreen;